<template>
  <div class="fixed inset-0" role="modal">
    <div
      @click="$emit('cancel')"
      data-test="background"
      class="fixed inset-0 bg-black opacity-60"
    ></div>
    <div class="container fixed bg-white shadow-lg max-w-full ui-modal">
      <header
        :class="{ 'bg-gray-100': heading }"
        class="flex absolute top-0 right-0 items-center justify-between py-3 pl-6 pr-2 pr-3"
      >
        <h2 class="heading-large">{{ heading || "" }}</h2>
        <button
          @click="$emit('cancel')"
          class="flex items-center justify-center w-8 h-8 text-gray-900 rounded-full hover:bg-gray-300"
        >
          <span class="sr-only">Schließen</span>
          <svg class="w-3 h-3 fill-current" viewBox="0 0 12 12">
            <path
              d="M7.41425 6.00001L11.7072 1.70701C12.0982 1.31601 12.0982 0.684006 11.7072 0.293006C11.3162 -0.0979941 10.6842 -0.0979941 10.2933 0.293006L6.00025 4.58601L1.70725 0.293006C1.31625 -0.0979941 0.68425 -0.0979941 0.29325 0.293006C-0.09775 0.684006 -0.09775 1.31601 0.29325 1.70701L4.58625 6.00001L0.29325 10.293C-0.09775 10.684 -0.09775 11.316 0.29325 11.707C0.48825 11.902 0.74425 12 1.00025 12C1.25625 12 1.51225 11.902 1.70725 11.707L6.00025 7.41401L10.2933 11.707C10.4882 11.902 10.7442 12 11.0002 12C11.2562 12 11.5122 11.902 11.7072 11.707C12.0982 11.316 12.0982 10.684 11.7072 10.293L7.41425 6.00001Z"
            />
          </svg>
        </button>
      </header>
      <main>
        <slot></slot>
      </main>
      <footer v-if="$slots.footer" class="flex justify-between p-6">
        <slot name="footer"></slot>
      </footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import UiDialog from "./UiDialog";

export default Vue.extend({
  extends: UiDialog,
  props: {
    heading: {
      type: String,
      required: false
    }
  },
  created() {
    document.addEventListener("keyup", ({ keyCode }) => {
      if (keyCode === 27) {
        this.$emit("cancel");
      }
    });
  }
});
</script>

<style scoped>
.ui-modal {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 800px;
}

@media (min-width: 360px) {
  .ui-modal {
    max-width: calc(100vw - 2rem);
  }
}
</style>
